'use client'
import {
  ABSOLUTE_FALLBACK_CURRENCY
} from "./chunk-VWPCKV3U.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-TYOTXCUK.mjs";

// src/context/root/context.ts
import { createContext } from "react";
var defaultState = {
  currency: ABSOLUTE_FALLBACK_CURRENCY,
  symbol: ABSOLUTE_FALLBACK_CURRENCY.symbol,
  detectedCurrency: "SAR"
};
var context_default = createContext(__spreadProps(__spreadValues({}, defaultState), {
  currencies: [],
  active: false,
  setCurrency: () => {
  },
  exchangePrice: (price, currency, format) => {
    if (format) {
      return `${price + (currency || "")}`;
    }
    return price;
  },
  unExchangePrice: (price, currency, format) => {
    if (format) {
      return `${price + (currency || "")}`;
    }
    return price;
  },
  exchangePriceForCurrency: (price, original, target, format) => __async(null, null, function* () {
    if (format) {
      return `${price + (original || "")}`;
    }
    return price;
  })
}));

export {
  defaultState,
  context_default
};
//# sourceMappingURL=chunk-5YUCCO3N.mjs.map